<template>
  <div class="BeforeQuestion">
      <section class="banner">
        <z-image width="700" height="200" px2rem src="n_v2f1ba900d3cd64f40b745d76af74176e7.png" />
      </section>

      <section>
        <div class="header">官方欺诈保障</div>
        <div class="content">
          <div class="item">
            <z-image width="45" height="42" src="n_v207cfe3a3aec444de8110b4e6d178adc5.png" />
            <div class="info">协助追款</div>
          </div>
          <div class="item">
            <z-image width="45" height="42" src="n_v254a4e29f92e746ddba3337e111cbe31a.png" />
            <div class="info">欺诈赔付</div>
          </div>
        </div>
      </section>

      <section>
        <div class="header">
          赔付规则
          <div class="moreinfo" @click="toMore()">更多细则<z-icon name="arrow" size="12px" /></div>
        </div>
        <div class="article">
          <div class="title" v-for="(item, idx) in KnowledgeList" :key="idx">
            <div class="title-index">{{ idx + 1 }}、</div>
            <div class="title-content">{{ item }}；</div>
          </div>
        </div>
      </section>

      <!-- <span>【receiveSource】：{{receiveSource}}（测试用）</span> -->
      <z-button-group v-show="!loading">
        <div class="tip">
          通过即可获得保障哦~
          <i class="tip-arrow"></i>
        </div>
        <z-button btn-class="bottombtn" type="primary" @click="toQuestion()">答题领取</z-button>
      </z-button-group>
    </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Icon, Button, ButtonGroup, Image } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'
import { queryParams } from '../../../lib/utils'
import { getReceiveCheck } from '../../../api/resourceApi'

const query = queryParams()
const KnowledgeList = [
  '须为实物商品交易',
  '交易全程在转转平台（包括但不限于：下单、支付、沟通等）',
  '订单状态为交易完成，且造成货物&钱款均在一方手中',
  '由平台判定欺诈事实成立',
  '须上传收货开箱/打包发货视频',
  '买卖双方的交易行为未违反《商品发布条例》等平台规则'
]
export default {
  name: 'BeforeQuestion',
  data() {
    return {
      receiveSource: query.receiveSource || this.$route.query.receiveSource || 'unknow', //领取来源。0:安全中心|1:push|2:私信3:重新领取
      loading: false,
      KnowledgeList,
      data: {
        receiveStatus: false /**0:未领取|1:已领取（生效中）|2:已领取（过期）**/
      }
    }
  },
  components: {
    zIcon: Icon,
    zButton: Button,
    zButtonGroup: ButtonGroup,
    zImage: Image
  },
  methods: {
    async getReceive() {
      this.loading = true
      // getReceiveCheck()
      //   .then((res) => {
      //     this.loading = false
      //     const { receiveStatus } = res || {}
      //     // this.data = res || {}
      //     if (+receiveStatus === 1) {
      //       // 申请校验
      //       return native.skipToUrl({
      //         targetUrl: `https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyReceive&receiveSource=${this.receiveSource}`,
      //         needClose: '1'
      //       })
      //     }
      //   })
      //   .catch((err) => {
      //     this.loading = false
      //     console.error(err)
      //   })
      const res = await getReceiveCheck()
      const { receiveStatus } = res || {}
      this.loading = false
      // this.data = res || {}
      if (+receiveStatus === 1) {
        // 申请校验
        return native.skipToUrl({
          targetUrl: `https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyReceive&receiveSource=${this.receiveSource}`,
          needClose: '1'
        })
      }
    },
    skip(targetUrl) {
      setTimeout(() => {
        native.skipToUrl({
          targetUrl
        })
      }, 300)
    },
    toMore(_value) {
      this.skip('https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyDescription')
    },
    toQuestion() {
      lego.send({
        pagetype: 'ZZUP_PAYMONEY',
        actiontype: 'BeforeQUESTION_CLICK',
        backup: {
          form: query.receiveSource || 'unknow'
        }
      })
      native.skipToUrl({
        targetUrl: `https://feentry.zhuanzhuan.com/spam?clientid=newSpamQua&source=12&receiveSource=${this.receiveSource}&entranceText=2`,
        needClose: '1'
      })
      // this.skip(`https://feentry.zhuanzhuan.com/spam_cloudInspection?clientid=SpamQuestion&receiveSource=${this.receiveSource}&source=3`)
    }
  },
  mounted() {
    native.setTitle({
      title: '放心转'
    })
    this.getReceive()
    lego.send({
      pagetype: 'ZZUP_PAYMONEY',
      actiontype: 'BeforeQUESTION_SHOW',
      backup: {
        form: query.receiveSource || 'unknow'
      }
    })
  },
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
